import React from 'react';
import propTypes from 'prop-types';
import { Table, CardBody } from 'reactstrap';
import Loading from 'react-loading-animation';

import { TextRupiah } from '../../../../components/Text';
import { _getFloatValue } from '../../../../utils/form';
import { connect } from 'react-redux';
import { bidDetailOfferSelector, bidDetailSelector } from '../../../../reducers/selectors/bidSelector';

const OfferSummaryCard = props => {
  const { paymentMethod } = props;
  const isFullWallet = paymentMethod === 'full_wallet';
  const totalAmount = _getFloatValue(props.totalAmount);
  const kickPoint = isFullWallet ? _getFloatValue(props.kickPoint) : 0;
  const sellerCredit = isFullWallet ? _getFloatValue(props.sellerCredit) : 0;
  const returnCredit = isFullWallet ? _getFloatValue(props.returnCredit) : 0;
  const kickCredit = isFullWallet
    ? Math.max(totalAmount - kickPoint - sellerCredit - returnCredit, 0)
    : 0;
  const totalCredit = isFullWallet
    ? kickCredit + kickPoint + sellerCredit + returnCredit
    : 0;
  return (
    <CardBody style={{padding: 0}}>
      {
        props.isLoading?
        <Loading/>:
        <Table>
          <thead>
            <tr>
              <th colSpan={2} className="text-center">
                Offer Summaries
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p style={{marginBottom: 0}}>{props.displayName}</p>
                <p style={{marginBottom: ".2rem", fontSize: '.75rem'}}>
                  <span style={{marginRight: '.2rem'}}>{`SIZE: ${props.sizeUS} US`}</span>
                  from: <TextRupiah prefix="Rp. " tag="span" value={_getFloatValue(props.originalPrice)}/>
                </p>
              </td>
              <td><TextRupiah prefix="Rp. " value={_getFloatValue(props.amount)} align="right" block/></td>
            </tr>
            <tr>
              <td>Processing Fee</td>
              <td><TextRupiah prefix="Rp. " value={_getFloatValue(props?.bidDetail?.processing_fee_calculated)} align="right" block/></td>
            </tr>
            <tr>
              <td>{props.kaCourier} {props.kaCourierOption} (1x)</td>
              <td><TextRupiah prefix="Rp. " value={_getFloatValue(props.kaCourierPrice)} align="right" block/></td>
            </tr>
            <tr>
              <td>Biaya Tambahan</td>
              <td><TextRupiah  prefix="Rp. " value={_getFloatValue(props.administrationFee)} align="right" block/></td>
            </tr>
            <tr>
              <td><b>Sub Total</b></td>
              <td>
                <TextRupiah prefix="Rp. " value={_getFloatValue(props.totalAmount)} align="right" block bold/>
              </td>
            </tr>
            {kickPoint > 0 && <tr>
              <td>Kick Point</td>
              <td>
                <TextRupiah prefix="-Rp. " value={_getFloatValue(kickPoint)} align="right" block/>
              </td>
            </tr>}
            {returnCredit > 0 && <tr>
              <td>Return Credit</td>
              <td>
                <TextRupiah prefix="-Rp. " value={_getFloatValue(returnCredit)} align="right" block/>
              </td>
            </tr>}
            {sellerCredit > 0 && <tr>
              <td>Seller Credit</td>
              <td>
                <TextRupiah prefix="-Rp. " value={_getFloatValue(sellerCredit)} align="right" block/>
              </td>
            </tr>}
            {kickCredit > 0 && <tr>
              <td>Kick Credit</td>
              <td>
                <TextRupiah prefix="-Rp. " value={_getFloatValue(kickCredit)} align="right" block/>
              </td>
            </tr>}
            <tr>
              <td><b>Total</b></td>
              <td>
                <TextRupiah prefix="Rp. " value={Math.max(totalAmount-totalCredit, 0)} align="right" block bold/>
              </td>
            </tr>
            <tr>
              <td>Deposit / Jaminan {(props.status==='NEW' || props.status==='ACCEPTED') && props.paymentMethod !== 'full_wallet' && Number(props.sellerCredit)? "(Use Seller Credit)":null}</td>
              <td>
                <TextRupiah prefix="Rp. " value={_getFloatValue((props.status==='NEW' || props.status==='ACCEPTED') && props.paymentMethod !== 'full_wallet'? props.depositAmount:0)} align="right" block/>
              </td>
            </tr>
          </tbody>
        </Table>
      }
    </CardBody>
  )
}

const mapStateToProps = state => ({
  bidDetailOffer: bidDetailOfferSelector(state),
  bidDetail: bidDetailSelector(state),
})

export default connect(mapStateToProps)(OfferSummaryCard);

OfferSummaryCard.propTypes = {
  id: propTypes.number,
  isLoading: propTypes.bool,
  displayName: propTypes.string,
  amount: propTypes.oneOfType([propTypes.number, propTypes.string]),
  kaCourier: propTypes.string,
  kaCourierOption: propTypes.string,
  kaCourierPrice: propTypes.oneOfType([propTypes.number, propTypes.string]),
  administrationFee: propTypes.oneOfType([propTypes.number, propTypes.string]),
  totalAmount: propTypes.oneOfType([propTypes.number, propTypes.string]),
  kickPoint: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sellerCredit: propTypes.oneOfType([propTypes.number, propTypes.string]),
  returnCredit: propTypes.oneOfType([propTypes.number, propTypes.string]),
  paymentMethod: propTypes.string,
  sizeUS: propTypes.string,
  originalPrice: propTypes.oneOfType([propTypes.number, propTypes.string])
}

OfferSummaryCard.defaultProps = {
  id: 0,
  isLoading: false,
  displayName: '-',
  amount: 0,
  kaCourierPrice: 0,
  administrationFee: 0,
  totalAmount: 0,
  kickPoint: 0,
  sellerCredit: 0,
  returnCredit: 0,
  paymentMethod: 'bank_tranfer',
  sizeUS: '-',
  originalPrice: 0
}
